import React, { useRef } from "react"
import styled from "styled-components"
import { useInView } from "react-intersection-observer"

const SVG = styled.svg`
  overflow: visible;
  .b {
    fill: #43b060;
  }
  .c,
  .e {
    opacity: 0.1;
  }
  .d {
    fill: #ffe75c;
  }
  .e {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 2px;
  }
  .f {
    fill: #ffb8b8;
  }

  .human {
    transition: all 1.5s;
    opacity: ${props => (props.inView ? 1 : 0)};
    transform: ${props =>
      props.inView ? "translate3d(0px,0,0)" : "translate3d(-30px,0,0)"};
  }
`
export default function StepTwo() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 })
  const humanRef = useRef(null)

  return (
    <SVG
      width="369.401"
      height="473.345"
      viewBox="0 0 369.401 473.345"
      ref={ref}
      inView={inView}
    >
      <g transform="translate(0 64.341)">
        <path fill="#535461" d="M13.766 9.937h259.536v384.042H13.766z" />
        <path class="d" d="M188.806 403.917L0 393.98V9.937L188.806 0z" />
        <circle
          cx="2.338"
          cy="2.338"
          r="2.338"
          transform="translate(170.686 218.033)"
        />
        <path d="M173.027 220.72l1.621 2.807 1.62 2.807h-6.483l1.62-2.807z" />
        <path class="d" d="M196.99 403.917l-11.564-.037L185.884 0h11.106z" />
        <circle
          class="c"
          cx="7.599"
          cy="7.599"
          r="7.599"
          transform="translate(165.425 195.821)"
        />
        <circle
          cx="7.599"
          cy="7.599"
          r="7.599"
          transform="translate(165.425 194.652)"
        />
        <g ref={humanRef} className="human">
          <path
            class="b"
            d="M233.943 97.478s-7.6 0-9.353 10.522-3.507 45.594-3.507 45.594-24.551 32.145-20.459 36.245 8.768 11.691 11.691 10.522 28.058-35.657 28.058-35.657z"
          />
          <path
            class="c"
            d="M233.943 97.478s-7.6 0-9.353 10.522-3.507 45.594-3.507 45.594-24.551 32.145-20.459 36.245 8.768 11.691 11.691 10.522 28.058-35.657 28.058-35.657z"
          />
          <path
            class="e"
            d="M30.875 9.379v386.409M64.194 7.041v389.916M97.512 5.287v393.917M130.831 3.534v398.099M164.15 1.78v400.346"
          />
          <ellipse
            cx="23.089"
            cy="21.628"
            rx="23.089"
            ry="21.628"
            transform="translate(247.679 34.056)"
          />
          <path
            class="f"
            d="M257.324 67.666s-.584 22.8-7.6 23.966-4.676 8.768-4.676 8.768 22.8 13.444 37.995 0l2.923-7.014s-10.522-7.6-5.845-18.121z"
          />
          <path d="M218.16 207.956s-34.488 64.3-21.628 84.174 32.15 60.787 35.073 60.787 19.29-8.184 18.121-13.444-18.705-44.425-23.381-47.932-2.338-12.86-1.754-13.444 19.874-31.565 19.874-31.565-.585 49.1 1.754 56.7-.585 61.961 2.338 64.3 16.367 6.43 18.705 2.923 9.353-56.7 4.676-68.976l8.768-84.174z" />
          <path d="M249.726 364.028l-14.613 26.889s-21.043 15.2-6.43 17.536 23.381-3.507 23.381-3.507l12.86-9.353v-26.889z" />
          <path d="M229.851 348.83l7.6 18.121s2.923 7.6 0 9.353-11.106 12.275-5.845 13.445a17.129 17.129 0 003.212.319 32.48 32.48 0 0023.614-9.609l4.739-4.739s-16.233-37.38-16.008-37.1-17.312 10.21-17.312 10.21z" />
          <path
            class="f"
            d="M271.937 41.947a19.874 19.874 0 11-19.874 19.874 19.874 19.874 0 0119.874-19.874z"
          />
          <path
            class="b"
            d="M283.336 89.586l-6.14 6.138s-18.705 7.014-27.473 0c0 0 3.215-6.722 3.215-6.138s-25.427 4.384-27.766 14.906 1.754 28.642 1.754 28.642-16.367 77.159-9.937 78.913 66.638 16.367 66.053 5.261 4.676-56.7 4.676-56.7l20.459-39.164s-2.923-12.86-9.937-16.952-14.904-14.906-14.904-14.906z"
          />
          <path
            class="f"
            d="M257.324 203.864l-7.6 4.676s-29.226 19.875-14.028 23.385 23.966-14.029 23.966-14.029l5.845-7.015z"
          />
          <path
            class="c"
            d="M300.58 117.937l5.261 5.261s3.507 49.1-3.507 59.039-39.164 36.826-40.918 35.072-12.86-10.522-10.522-11.691 33.426-33.652 33.426-33.652l-2.445-45.261z"
          />
          <path
            class="b"
            d="M302.919 116.183l5.261 5.261s3.507 49.1-3.507 59.039-39.164 36.826-40.918 35.072-12.86-10.522-10.522-11.691 33.426-33.652 33.426-33.652l-2.445-45.261z"
          />
          <path
            d="M263.719 33.592s-6.756-2.457-15.968 2.764l4.913 1.228s-7.37.614-8.291 10.441h3.378s-2.15 8.6 0 11.055l1.382-2.61 3.992 7.984.921-3.992 1.842.614 1.228-6.449s3.071 4.606 5.527 4.913v-3.993s6.756 7.677 8.905 7.37l-3.071-4.3 4.3.921-1.842-3.071 11.055 3.071-2.457-3.071 7.677 2.457 3.685 1.535s5.22-11.976-2.15-20.267-18.117-10.134-25.026-6.6z"
            fill="#010101"
          />
          <path
            d="M196.99 403.917l-11.564-.037L185.884 0h11.106z"
            fill="#fff"
            opacity=".4"
          />
          <path
            class="f"
            d="M203.547 190.42l-5.845 8.184s-28.058 5.845-17.536 14.613 25.72-8.184 25.72-8.184l8.184-10.522z"
          />
        </g>
      </g>
      <path
        d="M280.268 21.291c-8.213 5.853-32.347 1.477-45.3 5.124-18.37 5.171-16.431 11.752-.464 13.4 13.438 1.384 27.263-1.3 40.687.088 15.01 1.55 28.215 5.948 43.983 5.075 12.559-.7 33.009-.331 42.662-9.608 16.324-15.689-1.2-23.91-15.634-25.956-7.929-1.124-9.837 1.072-18.609-1.74-6.118-1.961-7.987-6.546-15.192-6.667-11.544-.2-21.978 10.031-27.06 18.6"
        stroke="#151539"
        stroke-miterlimit="10"
        stroke-width="2"
        fill="none"
      />
      <path
        d="M277.4 138.004s-4.456 2.294-6.34-.792"
        stroke="#000"
        fill="none"
        stroke-width=".99994"
      />
    </SVG>
  )
}
